/* istanbul ignore file */
import { useFilterContext } from './FilterContext';
import { useValidation } from 'framework/utils';

/**
 * Hook which provides form validation components.
 * @param fieldSource - source of the field that needs to be validated
 */
const useFilterValidation = (fieldSource = '') => {
  const { validationSchema, filters } = useFilterContext();

  const validationMethods = useValidation({
    data: filters,
    validationSchema,
    fieldSource,
  });

  return {
    ...validationMethods,
  };
};

export default useFilterValidation;
